<template>
  <div class="page">
    <list
      title="Pessoa Jurídica"
      tag="cnpj"
      subtitle="Nesta tela você cria e verifica os templates de consultas que possuem CNPJ como campo obrigatório."
      :create-route="{ name: 'Template-Legal-Person-Create' }"
    />
  </div>
</template>

<script>
import List from '@/template/components/List.vue';

export default {
  name: 'Index',

  components: {
    List,
  },
};
</script>

<style scoped>

</style>
